import {DomainStore} from 'shared/store';
import { makeAutoObservable } from 'mobx';
import {t} from 'shared/core';
import {endpoints, types} from 'main/tools';
import {successAlert} from 'shared/tools';
import {BenefitClass, CompanyInsuranceCarrier, EmployeeBenefitEnrollment} from 'main/stores/benefits';
import {Employee} from 'main/stores/employees';
import _ from 'lodash';
import EnrolmentViewModel from './EnrolmentViewModel';

class EmployeeBenefitChangeForm {
  store = new DomainStore();
  employeeId;
  history;

  employee;
  enrolmentViewModels = [];
  carriers = [];
  errors = {};

  constructor() {
    makeAutoObservable(this, {
      store: false,
      history: false
    });
  }

  receiveProps({employeeId, history}) {
    this.employeeId = employeeId;
    this.history = history;
  }

  async load() {
    await this.store._compose([
      endpoints.EMPLOYEE_DETAILS.with(this.employeeId),
      endpoints.EMPLOYEE.EMPLOYEE_BENEFIT_ENROLMENTS.with(this.employeeId),
      endpoints.COMPANY_INSURANCE_CARRIERS.WITH_OPTIONAL
    ]);

    const enrolments = this.store._getAll(
      types.EMPLOYEE_BENEFIT_ENROLLMENT, EmployeeBenefitEnrollment
    );

    this.enrolmentViewModels = enrolments.map(e => new EnrolmentViewModel(e));

    this.carriers = this.store._getAll(
      types.COMPANY_INSURANCE_CARRIER, CompanyInsuranceCarrier
    );

    this.benefitClasses = this.store._getAll(
      types.BENEFIT_CLASS, BenefitClass
    );

    this.employee = new Employee(
      this.store._getSingle(types.EMPLOYEE_DETAILS, { id: this.employeeId })
    );
  }

  async saveChanges() {
    const viewModels = _.filter(this.enrolmentViewModels, viewModel => viewModel.enrolmentChanged);
    const enrolments = viewModels.map(viewModel => viewModel.enrolment);

    if (_.isEmpty(enrolments)) {
      return this.history.push('/benefit_enrolments');
    }

    const {model, errors} = await this.store.post(
      endpoints.EMPLOYEE.CHANGE_ENROLMENTS.with(this.employeeId),
      types.EMPLOYEE_DETAILS,
      { employeeBenefitEnrollments: enrolments }
    );

    this.errors = errors;
    if (model) {
      successAlert(t('benefit_enrolment.change.Benefit enrolment classes changed'));
      this.history.push('/benefit_enrolments');
    }
  }

  get platform() {
    return 'Collage';
  }

  benefitClassesForCarrier(enrolment) {
    const carrier = _.find(
      this.carriers, c => _.find(c.benefitClasses, benefitClass => benefitClass.id === enrolment.benefitClass.id)
    );
    return carrier.benefitClasses;
  }
}

export default EmployeeBenefitChangeForm;
